import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAssetsTools = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8.75 2.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.25 11a.75.75 0 0 1 .75-.75h3.645a3 3 0 0 1 1.993.758l3.48 3.094 2.332-1.165a5.932 5.932 0 0 1 7.683 2.161.755.755 0 0 1-.261 1.054l-8.276 4.79a6 6 0 0 1-3.006.808H3.5a.75.75 0 0 1 0-1.5h6.687a6 6 0 0 0 3.006-.807l7.202-4.17a4.433 4.433 0 0 0-5.274-.995l-2.77 1.385a.68.68 0 0 1-.03.015l-2.144 1.072H5a.75.75 0 0 1 0-1.5h4.823l.85-.425-2.606-2.317a3 3 0 0 0-1.993-.758H3a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorAssetsTools;
